import "primevue/resources/themes/bootstrap4-light-blue/theme.css"
import 'jquery/dist/jquery'
import 'bootstrap/dist/js/bootstrap'
import "@lottiefiles/lottie-player"
import 'primeflex/primeflex.css';
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import DynamicDialog from 'primevue/dynamicdialog';
import DialogService from 'primevue/dialogservice';
import Dropdown from 'primevue/dropdown';
import ProgressSpinner from 'primevue/progressspinner';
import Image from 'primevue/image';
import FileUpload from 'primevue/fileupload';
import DataTableBackend from '@/components/DataTableBackend.vue';
import Editor from "primevue/editor";
import InputNumber from 'primevue/inputnumber';
import AutoComplete from 'primevue/autocomplete';
import ProgressBar from 'primevue/progressbar';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Toast from 'primevue/toast'; 
import ToastService from 'primevue/toastservice';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
import SelectButton from 'primevue/selectbutton';
import SpeedDial from 'primevue/speeddial';
import MultiSelect from 'primevue/multiselect';
import ExportTable from "@/components/ExportTable.vue";
import AddResource from '@/components/AddResource.vue';
import YamsTemplate from '@/layouts/YamsTemplate.vue'
import Pusher from 'pusher-js';
import InvoiceRenderer from '@/components/InvoiceRenderer.vue';
import InvoiceEditor from '@/components/InvoiceEditor.vue';
import { FormatService } from '@/services/FormatService';

//parametres cors et la base url des requetes dans la spa
axios.defaults.withCredentials = true
axios.defaults.baseURL = store.getters.apiUrl


//si l'utilisateur s'est déjà connecté
const mysession = window.localStorage.getItem("espace_yamslogistics_session")

if(mysession !== null){
  const userDatas = JSON.parse(mysession);
  store.commit('setAuthenticated', userDatas);
  axios.defaults.headers.common = {
    'Authorization': 'Bearer ' + userDatas.token
  }
  // Configuration pour les requêtes d’authentification des channels privés/présence
  Pusher.logToConsole = true

  const pusher = new Pusher("829d13f31922516e15fd", {
    cluster: "eu",
    authEndpoint: store.getters.apiUrl + "/broadcasting/auth",
    auth: {
      headers: {
        Authorization: 'Bearer ' + userDatas.token,
        Accept: "application/json"
      }
    }
  })

  // S'abonner à un channel de présence
  const presenceChannel = pusher.subscribe('presence-app')

  presenceChannel.bind('pusher:subscription_succeeded', (members: any) => {
    console.log('Utilisateurs connectés :', members)
  })

  presenceChannel.bind('pusher:member_added', (member: any) => {
    console.log(member.info.name + "s'est connecté")
  })

  presenceChannel.bind('pusher:member_removed', (member: any) => {
    console.log(member.info.name + "s'est connecté")
  })

  // Écoute d’un event personnalisé
  presenceChannel.bind('refresh', (data: any) => {
    console.log("Nouvelle donnée reçue :", data)
  })

  
}

// redirriger si l'utilisateur n'est pas connecté
axios.interceptors.response.use((response: any)=>{
    if(response.status==401){
            store.commit('clearUserData')
            router.push({ name: 'login' })
        } else {
            return response
        }
    },
    (error)=>{
        if(error.response.status==401){
            store.commit('clearUserData')
            router.push({ name: 'login' })
        }
    },
);

const app = createApp(App);
app.use(VueAxios, axios)
app.use(PrimeVue)
app.use(store)
app.use(router)
app.use(DialogService)
app.use(ToastService)
app.component('YamsTemplate', YamsTemplate);
app.component('DataTable', DataTable);
app.component('DataTableColumn', Column);
app.component('DataPaginator', Paginator);
app.component('DynamicDialog', DynamicDialog);
app.component('SearchDropdown', Dropdown);
app.component('ProgressSpinner', ProgressSpinner);
app.component('ShowImage', Image);
app.component('FileUpload', FileUpload);
app.component('TextEditor', Editor);
app.component('InputNumber', InputNumber);
app.component('AutoComplete', AutoComplete);
app.component('ProgressBar', ProgressBar);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('ShowToast', Toast);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('ChartJS', Chart);
app.component('SelectButton', SelectButton);
app.component('SpeedDial', SpeedDial);
app.component('MultiSelect', MultiSelect);
app.component('DataTableBackend', DataTableBackend);
app.component('ExportTable', ExportTable);
app.component('InvoiceRenderer', InvoiceRenderer);
app.component('InvoiceEditor', InvoiceEditor);
app.component('AddResource', AddResource);

// Ajout des fonctions globales
app.config.globalProperties.$moneyFormat = FormatService.moneyFormat;
app.config.globalProperties.$dateFormat = FormatService.dateFormat;

app.mount('#app')